module.exports = __webpack_public_path__ + "img/jianzhu.2d5979dc.png";